module.exports = __webpack_public_path__ + "img/input-spinner.40872ad9.gif";